import { render, staticRenderFns } from "./AccountSettingsBilling.vue?vue&type=template&id=a5b0cad8&"
import script from "./AccountSettingsBilling.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports